import React from 'react';

import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';

const LogoSmall = (): React.JSX.Element => {
	return <AtlassianIcon size="small" appearance="brand" />;
};

export default LogoSmall;
